// extracted by mini-css-extract-plugin
export var compactFilters = "_he-4";
export var detailImage = "_he-1";
export var dropdownContainer = "_he-2";
export var imageContainer = "_he-0";
export var selectedCard = "_he-3";